import { URLS } from '../constants'
import { dispatchFetchPost } from './ActionsUtil'
import {
  LOGOUT,
  LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_FAILURE,
  CLEAR_LOGIN_ERROR_STATE,
  RECONNECT_BEGIN, RECONNECT_SUCCESS, RECONNECT_FAILURE,
  MAIL_VERIFICATION_REQUEST_BEGIN, MAIL_VERIFICATION_REQUEST_SUCCESS, MAIL_VERIFICATION_REQUEST_FAILURE,
} from '../constants/ActionTypes'

//:: Login
const acPostLoginBegin = () => ({ type: LOGIN_BEGIN })
const acPostLoginSuccess = user => ({ type: LOGIN_SUCCESS, payload: user })
const acPostLoginFailure = err => ({ type: LOGIN_FAILURE, payload: err })

export const acPostLogin = ({ login, password }) => {
  return dispatchFetchPost(
    URLS.LOGIN,
    { login, password },
    acPostLoginBegin,
    acPostLoginSuccess,
    acPostLoginFailure
  )
}

//:: Logout
export const acLogout = () => ({ type: LOGOUT })

//:: Reconnect
const acPostReconnectBegin = () => ({ type: RECONNECT_BEGIN })
const acPostReconnectSuccess = data => ({ type: RECONNECT_SUCCESS, payload: data })
const acPostReconnectFailure = err => ({ type: RECONNECT_FAILURE, payload: err })

export const acPostReconnect = () => {
  return dispatchFetchPost(
    URLS.RECONNECT, {},
    acPostReconnectBegin,
    acPostReconnectSuccess,
    acPostReconnectFailure
  )
}

//:: Login Alerts State
export const acClearLoginErrorState = () => ({ type: CLEAR_LOGIN_ERROR_STATE })


// Mail Verification Request
const acMailVerificationRequestBegin = () => ({ type: MAIL_VERIFICATION_REQUEST_BEGIN })
const acMailVerificationRequestSuccess = res => ({ type: MAIL_VERIFICATION_REQUEST_SUCCESS, payload: res })
const acMailVerificationRequestFailure = err => ({ type: MAIL_VERIFICATION_REQUEST_FAILURE, payload: err })

export const acMailVerificationRequest = ({ email }) => {
  return dispatchFetchPost(
    URLS.MAIL_VERIFICATION.REQUEST,
    { email },
    acMailVerificationRequestBegin,
    acMailVerificationRequestSuccess,
    acMailVerificationRequestFailure
  )
}